import React from 'react';
import { Stack, Text } from '@fluentui/react';
import CallActionBarDivider from './Divider';
import IvicosStrings from 'kits/language/stringKit';
import { ICallActionGroup } from '../CallActionBar';
import { ICallAction } from 'features/Rooms/RoomView/CallActions';
import CallActionButton from '../Children/CallActionButton/CallActionButton';

interface Props {
    actionGroup: ICallActionGroup;
    index: number;
    totalGroups: number;
    showHoverButton: boolean;
    onMouseEnter: () => void;
    onMouseLeave: () => void;
    isVisitorAtLandingPage: boolean;
    onActionPressed: (a: ICallAction) => void;
    micIsMuted: boolean;
    cameraIsMuted: boolean;
    sharingIsOn: boolean;
    statsAreVisible: boolean;
    isLocalUserHandRaised: boolean;
    isChatVisible?: boolean;
}

const ActionGroup: React.FC<Props> = ({
    actionGroup,
    index,
    totalGroups,
    showHoverButton,
    onMouseEnter,
    onMouseLeave,
    isVisitorAtLandingPage,
    onActionPressed,
    micIsMuted,
    cameraIsMuted,
    sharingIsOn,
    statsAreVisible,
    isLocalUserHandRaised,
    isChatVisible
}) => {
    if (actionGroup.actions.length === 0) return null;

    const isAttachmentGroup = actionGroup.actions.some((a) => a.key === 'toggle-hover-attachments');
    const filteredActions = actionGroup.actions.filter((action) => {
        if (!isAttachmentGroup) return true;
        return showHoverButton ? action.key === 'toggle-hover-attachments' : action.key !== 'toggle-hover-attachments';
    });

    const expandedWidth = 20 + (actionGroup.actions.length - 1) * 40;
    const styles = isAttachmentGroup
        ? {
              root: {
                  width: showHoverButton ? '40px' : `${expandedWidth}px`,
                  transition: 'width 300ms',
                  ':hover': { width: `${expandedWidth}px` }
              }
          }
        : undefined;

    return (
        <>
            <Stack
                horizontal
                verticalAlign="center"
                horizontalAlign="center"
                tokens={{ childrenGap: 8 }}
                styles={styles}
                onMouseEnter={isAttachmentGroup ? onMouseEnter : undefined}
                onMouseLeave={isAttachmentGroup ? onMouseLeave : undefined}
            >
                {filteredActions.map((action) => (
                    <CallActionButton
                        key={action.key}
                        action={action}
                        onPressed={onActionPressed}
                        micIsMuted={micIsMuted}
                        cameraIsMuted={cameraIsMuted}
                        sharingIsOn={sharingIsOn}
                        statsAreVisible={statsAreVisible}
                        isLocalUserHandRaised={isLocalUserHandRaised}
                        isChatVisible={isChatVisible}
                    />
                ))}
            </Stack>
            {isVisitorAtLandingPage && (
                <Stack style={{ height: '100%' }} verticalAlign="center">
                    <Text variant="medium">{IvicosStrings.callActionButtonSelectBackground}</Text>
                </Stack>
            )}
            {index < totalGroups - 1 && <CallActionBarDivider />}
        </>
    );
};

export default ActionGroup;
